import {
  BottomSheetContainer,
  createUseBottomSheetModal,
  Flex,
  PrimaryButton,
  Typography,
} from '@banhala/ui-kit';
import { BirthdayForm } from './BirthdayForm';
import { InvitationCodeForm } from './InvitationCodeForm';

/**
 * 소셜 신규가입(카카오/애플) 완료 드로어. (webview RegisterCompleteDrawer 대응)
 * isShowBirthdate면 생년월일 입력을 노출하고, 초대코드 입력은 항상 노출한다.
 * 닫으면(쇼핑하러 가기/닫기) 호출측(useConsumePendingSocialAuth)에서 redirect한다.
 */
export const useRegisterCompleteBottomSheet = createUseBottomSheetModal<
  void,
  { isShowBirthdate: boolean }
>(({ confirm, cancel, param }) => {
  return (
    <BottomSheetContainer title={'가입완료'} onPressClose={cancel}>
      <Flex padding={{ horizontal: 16, top: 8, bottom: 24 }} gap={20}>
        <Typography type={'h4'} color={'content_primary'}>
          {'회원가입이 완료되었어요!'}
        </Typography>
        {param.isShowBirthdate && <BirthdayForm />}
        <InvitationCodeForm />
        <PrimaryButton
          variant={'fill'}
          color={'gray'}
          size={'xlarge'}
          onPress={() => confirm()}
        >
          {'쇼핑하러 가기'}
        </PrimaryButton>
      </Flex>
    </BottomSheetContainer>
  );
});
